import React, {Component, Fragment} from 'react'
import * as mobx from 'mobx'
import {inject, observer} from 'mobx-react'
import {Col, Container, FormGroup, Input, Label, Row,} from 'reactstrap'
import moment from 'moment'

import {priorities, statuses} from "../models";
import {CopyToClipboardButton, DatePicker, FormControlButton, Selector, Spinner} from '../../../components'
import {WorkflowUserSelector} from "../../../services/users/WorkflowUserSelector";
import WorkflowStatus from "./WorkflowTaskStatus";
import WorkflowTaskPriority from "./WorkflowTaskPriority";
import {WorkflowTaskCategory} from "./WorkflowTaskCategory";
import {TryEdit} from "./TryEdit";
import {LocationSelector} from "../../../services/locations/LocationSelector";
import accessStore from "../../../services/locations/AccessStore";
import {UserOrLoading} from "../../../services/users/components/UserOrLoading";
import {Username} from "../../../services/users/components/Username";
import userResolver from "../../../services/users/UserResolver";
import {formatPostalAddress} from "../../../services/locations/locationAddress/util";

const NotEditing = (props) => <div {...props}/>

const none = <span className="text-muted">None</span>;

export const WorkflowTaskForm = inject("taskStore")(observer(class WorkflowTaskForm extends React.Component {
  state = {}


  render() {

    return <Container>
      <Row>
        <Col sm="3"><TaskCategory /></Col>
        <Col sm="6"><TryEdit><TaskName /></TryEdit></Col>
        <Col sm="3"><TaskId /></Col>
      </Row>
      <Row>
        <Col sm="3"><TryEdit><TaskStatus /></TryEdit></Col>
        <Col sm="3"><TryEdit><TaskPriority /></TryEdit></Col>
        <Col sm="3"><TryEdit><TaskAssignee /></TryEdit></Col>
        <Col sm="3"><TryEdit><TaskDueDate /></TryEdit></Col>
      </Row>
      <Row>
        <Col sm="12"><TryEdit><TaskLocation /></TryEdit></Col>
      </Row>
    </Container>
  }
}));
//does this need to be an observer or the task store injected?
export const WorkflowTaskFormVertical = inject("taskStore")(observer(class WorkflowTaskFormVertical extends React.Component {
  render() {
    return <Fragment>
      <div className="row">
        <div className="col-12"><TaskCategory /></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-name"><TryEdit><TaskName /></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-status"><TryEdit><TaskStatus /></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-priority"><TryEdit><TaskPriority /></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-assignee"><TryEdit><TaskAssignee /></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-due-date"><TryEdit><TaskDueDate/></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12" data-testid="task-location"><TryEdit><TaskLocation/></TryEdit></div>
      </div>
      <div className="row">
        <div className="col-12"><TaskId/></div>
      </div>
    </Fragment>
  }
}));

const TaskCategory = inject("taskStore")(observer(class TaskCategory extends Component {
  render() {
    return <FormGroup>
      <Label className="font-weight-bold">Task Type</Label>
      <div><WorkflowTaskCategory size="sm" value={this.props.taskStore.editing.category}/></div>
    </FormGroup>
  }
}));

const TaskName = inject("taskStore")(observer(class TaskName extends Component {
  setTaskName = event => this.props.taskStore.setTaskName(event.target.value)

  render() {
    const store = this.props.taskStore;
    const task = store.editing
    const showInvalid = store.shouldShowInvalid('taskName')
    const isEditing = this.props.taskStore.isEditMode;
    return <FormGroup>
      <Label className="font-weight-bold">Task Name</Label>
      {
        isEditing
          ? <Input
            type="text"
            value={task.taskName}
            className={showInvalid ? 'is-invalid' : ''}
            disabled={!isEditing}
            onChange={this.setTaskName}/>
          : <NotEditing>{task.taskName}</NotEditing>
      }
    </FormGroup>

  }
}));

const TaskId = inject("taskStore")(observer(class TaskId extends Component {

  render() {
    const task = this.props.taskStore.editing;
    return (<div className="form-group">
      <Label className="font-weight-bold">Task ID</Label>
      <div style={{padding: "0.375rem 0.75rem"}}>
        {task.prefixedFriendlyId || 'N/A'}
      </div>
    </div>);
  }
}));

const TaskStatus = inject("taskStore")(observer(class TaskStatus extends Component {

  setStatus = status => this.props.taskStore.setStatus(status && status.value)

  render() {
    const status = this.props.taskStore.editing.status
    let found = statuses.find(x => x.value === status);
    let editMode = this.props.taskStore.isEditMode;

    return <FormGroup>
      <Label className="font-weight-bold">Task Status</Label>
      {editMode
        ? <Selector
          required
          selected={found}
          options={statuses}
          renderOption={x => <WorkflowStatus status={x.value}/>}
          getKey={x => x.value}
          placeholder={none}
          onSelected={this.setStatus}
        />
        : <NotEditing><WorkflowStatus status={status}/></NotEditing>
      }
    </FormGroup>
  }
}));

const TaskPriority = inject("taskStore")(observer(class TaskPriority extends Component {

  setPriority = selection => this.props.taskStore.setPriority(selection && selection.value)
  render() {
    const priority = this.props.taskStore.editing.priority
    let editMode = this.props.taskStore.isEditMode;
    return <FormGroup>
      <Label className="font-weight-bold">Priority</Label>
      {
        editMode
          ? <Selector
            required
            selected={priorities.find(x => x.value === priority)}
            options={priorities}
            renderOption={x => <WorkflowTaskPriority priority={x.nameValue}/>}
            getKey={x => x.value}
            placeholder={none}
            onSelected={this.setPriority}
          />
          : <NotEditing><WorkflowTaskPriority priority={priority}/></NotEditing>
      }

    </FormGroup>
  }
}));

const TaskAssignee = inject("taskStore")(observer(class TaskAssignee extends Component {

  render() {
    const assignee = this.props.taskStore.editing.assignee
    const model = assignee && userResolver.fetchOne(assignee.userId || assignee.id)
    let editMode = this.props.taskStore.isEditMode;
    let component;
    if (editMode) {
      component = <WorkflowUserSelector
        selected={model && model.isLoaded ? model.user : assignee}
        placeholder={none}
        onSelected={this.props.taskStore.setAssignee}
      />
    } else if (!assignee) {
      component = <NotEditing>none</NotEditing>
    } else {
      component = <NotEditing><UserOrLoading chipSize="sm" user={model}/></NotEditing>
    }
    return <FormGroup>
      <Label className="font-weight-bold">Assignee</Label>
      {component}
    </FormGroup>
  }
}));

const TaskDueDate = inject("taskStore")(observer(class TaskDueDate extends Component {

  render() {
    const dueDate = this.props.taskStore.editing.dueDate
    let editMode = this.props.taskStore.isEditMode;
    return <FormGroup>
      <Label className="font-weight-bold">Due Date</Label>
      {
        editMode
          ? <DatePicker
            disabled={!editMode}
            placeholder={none}
            onChange={this.props.taskStore.setDueDate}
            date={dueDate}
          />
          : <NotEditing>{dueDate ? moment(dueDate).format('MM/DD/YY') : none}</NotEditing>
      }
    </FormGroup>
  }
}));

const TaskLocation = inject("taskStore")(observer(class TaskLocation extends Component {
  render() {
    let editMode = this.props.taskStore.isEditMode;
    const locationId = this.props.taskStore.editing.locationId;
    const location = locationId && accessStore.getLocation(locationId)
    return <FormGroup>
      <Label className="font-weight-bold">Location</Label>
      {
      editMode ? <LocationSelector
      placeholder={<span className="text-muted">Location</span>}
      disabled={this.props.taskStore.editing.taskType !== 'Custom'}
      selected={locationId}
      onSelected={this.onSelected} /> : <NotEditing>
      {location
        ? <span>{location.name}  <br /> {formatPostalAddress(location.address)} </span>
        : <span className="text-muted">None</span>}
    </NotEditing>
    }</FormGroup>
  }

  onSelected = (locationId) => {
    this.props.taskStore.setLocationId(locationId);
  }
}));